import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = {
  class: "spShoppingLocationsLabel d-none d-lg-block",
  id: "spShoppingLocationsLabel"
}
const _hoisted_3 = {
  class: "zipLocation--code",
  id: "ancHeaderZipcode",
  role: "link",
  href: "javascript:void(0);"
}
const _hoisted_4 = { id: "ZipcodeInformationHeader" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("g", null, [
          /*#__PURE__*/_createElementVNode("path", {
            d: "M0 0L24 0 24 24 0 24z",
            transform: "translate(-1138 -24) translate(1017 20) translate(121 4)"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            fill: "#242C33",
            "fill-rule": "nonzero",
            d: "M18.364 16.364L12 22.728l-6.364-6.364c-3.515-3.515-3.515-9.213 0-12.728 3.515-3.515 9.213-3.515 12.728 0 3.515 3.515 3.515 9.213 0 12.728zM12 12c1.105 0 2-.896 2-2 0-1.105-.895-2-2-2s-2 .895-2 2c0 1.104.895 2 2 2z",
            transform: "translate(-1138 -24) translate(1017 20) translate(121 4)"
          })
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "zipLocation text-right",
    id: "zipLocation",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.handleZipLocationClick && $options.handleZipLocationClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('Picking up closest to')), 1),
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString($props.zipcode), 1)
      ])
    ]),
    _hoisted_5
  ]))
}